/**
 * Enter/leave preview wrappers animate a `translate` on an element that is
 * nested inside the item's rotation transform (DraggableComponent applies
 * `rotate(deg)` on the parent). A raw translate would therefore move along the
 * item's rotated axes, so an "enter from left" on a 90°-rotated item would slide
 * in from the top.
 *
 * Counter-rotating the offset by `-rotation` cancels the parent's rotation, so
 * the resulting on-screen motion stays axis-aligned (left/right/top/bottom)
 * regardless of how the item is rotated.
 */
export const counterRotateOffset = (
  offset: { x: number; y: number },
  rotation = 0
): { x: number; y: number } => {
  if (!rotation) return offset;
  // CSS `rotate(θ)` (y-axis points down) maps a vector by [cos, -sin; sin, cos],
  // so the inverse that pre-cancels it is [cos, sin; -sin, cos].
  const rad = (rotation * Math.PI) / 180;
  const cos = Math.cos(rad);
  const sin = Math.sin(rad);
  return {
    x: offset.x * cos + offset.y * sin,
    y: -offset.x * sin + offset.y * cos,
  };
};
